import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

/**
 * Hook to manage evaluation sessions for player check-in
 */
export function useSessions(selectedPlayer: any, forceDate: string | null) {
  const [todaysSessions, setTodaysSessions] = useState<any[]>([]);
  const [selectedSession, setSelectedSession] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  // Get today's date string in YYYY-MM-DD format
  const getTodayString = () => {
    const today = new Date();
    const timezoneOffsetInMS = today.getTimezoneOffset() * 60000; // convert minutes to milliseconds
    const localDate = new Date(today.getTime() - timezoneOffsetInMS);
    return localDate.toISOString().slice(0, 10);
  };

  const todayStr = getTodayString();

  // Fetch sessions based on player and date
  useEffect(() => {
    async function fetchSessions() {
      setError('');
      setTodaysSessions([]);
      setSelectedSession(null);

      // Determine which date to use: ?force=YYYY-MM-DD or today
      const sessionDate = forceDate || todayStr;

      let query = supabase
        .from('evaluation_sessions')
        .select(`
          id, 
          session_date, 
          start_time, 
          end_time, 
          location_name, 
          evaluation_session_age_groups!inner(
            age_group_id,
            age_groups(id, group_name, sex)
          )
        `)
        .order('start_time', { ascending: true })
        .eq('session_date', sessionDate);

      const { data, error: sessionError } = await query;

      if (sessionError) {
        console.error('Failed to fetch sessions:', sessionError);
        setError(sessionError.message);
        return;
      }

      if (data && data.length > 0) {
        setTodaysSessions(data);
        // If there's exactly 1 session, select it automatically.
        if (data.length === 1) {
          setSelectedSession(data[0]);
        }
      } else {
        setError(`No evaluation session found for ${sessionDate}.`);
      }
    }
    fetchSessions();
  }, [selectedPlayer, forceDate, todayStr]);

  return {
    todaysSessions,
    selectedSession,
    setSelectedSession,
    todayStr,
    error
  };
}
